(function () {
    const dataEl = document.getElementById('StoreLocatorData');
    const mapEl = document.getElementById('StoreLocatorMap');
    const listEl = document.getElementById('StoreLocatorList');
    const countEl = document.getElementById('StoreLocatorCount');
    const selectEl = document.getElementById('StoreLocatorProvince');

    if (!dataEl || !mapEl) return;

    const stores = JSON.parse(dataEl.textContent);
    const isMobile = function () {
        return window.matchMedia('(max-width: 989px)').matches;
    };

    let isProgrammaticScroll = false;
    let programmaticScrollTimer = null;

    const map = L.map('StoreLocatorMap').setView([13.7563, 100.5018], 6);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', maxZoom: 18,
    }).addTo(map);

    const pinIcon = L.divIcon({
        className: 'store-locator__pin',
        html: '<svg width="24" height="36" viewBox="0 0 24 36"><path d="M12 0C5.4 0 0 5.4 0 12c0 9 12 24 12 24s12-15 12-24C24 5.4 18.6 0 12 0zm0 18c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 6-2.7 6-6 6z" fill="#000"/></svg>',
        iconSize: [24, 36],
        iconAnchor: [12, 36],
        popupAnchor: [0, -36],
    });

    // markers[i] = { marker, store, card } - card is set in renderList() 
    const markers = [];
    const provinces = new Set();

    stores.forEach(function (store, index) {
        if (!store.lat || !store.lng) return;

        provinces.add(store.province);

        const popupContent = 
          '<div class="store-locator__popup">' + 
          '<strong>' + store.name + '</strong>' + 
          '<p>' + store.address + '</p>' +
          (store.phone ? '<p>' + store.phone + '</p>' : '') + 
          (store.hours ? '<p>' + store.hours + '</p>' : '') +
          '</div>';

        const marker = L.marker([store.lat, store.lng], { icon: pinIcon })
            .bindPopup(popupContent)
            .addTo(map);

        // Click pin -> activate matching card
        marker.on('click', function () {
            activateStore(store, { fromMap: true});
        });

        markers.push({ marker: marker, store: store, card: null, index: index });
    });

    var sortedProvinces = Array.from(provinces).sort();
    sortedProvinces.forEach(function (province) {
        var option = document.createElement('option');
        option.value = province;
        option.textContent = province;
        selectEl.appendChild(option);
    });

    // IntersectionObserver: detect which card is centered (mobile swipe)
    let cardObserver = null;

    function setupCardObserver() {
        if (cardObserver) cardObserver.disconnect();
        if (!isMobile()) return;

        cardObserver = new IntersectionObserver(function (entries) {
            if (isProgrammaticScroll) return;

            // Pick the most-visible card from the batch
            let best = null;
            entries.forEach(function (entry) {
                if (entry.intersectionRatio < 0.6) return;
                if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
            });
            if (!best) return;

            const store = JSON.parse(best.target.dataset.store);
            activateStore(store, { fromMap: false, skipScroll: true});
        }, {root: listEl, threshold: [0.6, 0.8, 1]});

        Array.prototype.forEach.call(listEl.querySelectorAll('.store-locator__card'), function (card) {
            cardObserver.observe(card);
        });
    }

    function renderList(filteredStores) {
        listEl.innerHTML = '';
        // Reset card reference on markers
        markers.forEach(function (m) { m.card = null; });

        filteredStores.forEach(function (store) {
            var card = document.createElement('div');
            card.className = 'store-locator__card';
            card.dataset.store = JSON.stringify({ lat: store.lat, lng: store.lng, name: store.name});
            card.innerHTML = 
              '<h3 class="store-locator__card-name">' + store.name + '</h3>' +
              '<p class="store-locator__card-address">' + store.address + '</p>' +
              (store.phone
                ? '<p class="store-locator__card-phone"><a href="tel:' + store.phone +
                '">' + store.phone + '</a></p>'
                : '') +
                (store.hours ? '<p class="store-locator__card-hours">' + store.hours + '</p>' : '');
        
            card.addEventListener('click', function () {
                activateStore(store, { fromMap: false});
            });

            listEl.appendChild(card);

            // Link card back to its marker
            const m = markers.find(function (mm) { return mm.store === store; });
            if (m) m.card = card;
        });

        countEl.textContent = filteredStores.length + ' / ' + stores.length + ' stores';

        // Rebind observer to new cards
        setupCardObserver();
    }

    // Single point of truth for "this store is now active"
    function activateStore(store, opts) {
        opts = opts || {};

        // Visual: mark only this card .is-active
        Array.prototype.forEach.call(listEl.querySelectorAll('.store-locator__card'), function (c) {
            c.classList.remove('is-active');
        });

        // Match by coords + name (reference equality fails when store comes from JSON.parse)
        const m = markers.find(function (mm) {
            return mm.store.lat === store.lat && mm.store.lng === store.lng && mm.store.name === store.name;
        });
        if (m && m.card) m.card.classList.add('is-active');

        // Pan map + open popup (unless called from map click, where Leaflet handles popup)
        if (store.lat && store.lng) {
            map.setView([store.lat, store.lng], 15);
            if (m && !opts.fromMap) m.marker.openPopup();
        }

        // Scroll card into view (unless suppressed). Pin click -> center; card click -> nearest.
        if (m && m.card && !opts.skipScroll) {
            isProgrammaticScroll = true;
            m.card.scrollIntoView({
                behavior: 'smooth',
                block: opts.fromMap ? 'center' : 'nearest',
                inline: isMobile() ? 'center' : 'nearest'
            });
            clearTimeout(programmaticScrollTimer);
            programmaticScrollTimer = setTimeout(function () {
                isProgrammaticScroll = false;
            }, 600);
        }
    }

    function filterStores(province) {
        var filtered = province === 'all' ? stores : stores.filter(function (s) {
            return s.province === province; 
        });

        markers.forEach(function (m) {
            if (province === 'all' || m.store.province === province) {
                m.marker.addTo(map);
            } else {
                map.removeLayer(m.marker);
            }
        });

        var visibleMarkers = markers.filter(function (m) {
            return province == 'all' || m.store.province == province;
        });

        if (visibleMarkers.length > 0) {
            var group = L.featureGroup(visibleMarkers.map(function (m) { return m.marker}));
            map.fitBounds(group.getBounds().pad(0.1));
        }

        renderList(filtered);
    }

    selectEl.addEventListener('change', function () {
        filterStores(this.value);
    });

    // Re-evaluate observer on viewport change (desktop <-> mobile)
    window.addEventListener('resize', function () {
        setupCardObserver();
    });

    // Drag-to-scroll: lets mouse users swipe the horizontal card strip on mobile
    // (native touch swipe works on real devices / DevTools device mode; this covers plain mouse)
    const drag = { down: false, startX: 0, startScrollLeft: 0, moved: false };

    listEl.addEventListener('mousedown', function (e) {
        if (!isMobile()) return;
        drag.down = true;
        drag.moved = false;
        drag.startX = e.pageX;
        drag.startScrollLeft = listEl.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
        drag.down = false;
    });

    listEl.addEventListener('mousemove', function (e) {
        if (!drag.down) return;
        e.preventDefault();
        const walk = e.pageX - drag.startX;
        if (Math.abs(walk) > 5) drag.moved = true;
        listEl.scrollLeft = drag.startScrollLeft - walk;
    });

    // Swallow the synthetic click that fires after a drag, so card click handler doesn't trigger
    listEl.addEventListener('click', function (e) {
        if (drag.moved) {
            e.stopPropagation();
            e.preventDefault();
            drag.moved = false;
        }
    }, true);

    renderList(stores);

    if (markers.length > 0) {
        var allGroup = L.featureGroup(markers.map(function (m) { return m.marker; }));
        map.fitBounds(allGroup.getBounds().pad(0.1));
    }
})();